<div class="card card-nc" *ngIf="hasEntitlement('REGISTER_SHIP')">
  <div class="card-heading">
    <i class="fa fa-ship"></i>
    <span class="cardHeaderHeading"> Register New Merchant </span>
  </div>
  <div class="card-body">
    <form name="merchantForm" [formGroup]="merchantsForm" (ngSubmit)="onSubmit()">
      <div class="card card-nc">
        <div class="card-body">
          <h5 *ngIf="merchants?.length < 1">No Merchants found</h5>
          <table *ngIf="merchants?.length" class="table table-striped table-bordered table-hover">
            <thead class="tableheading">
            <tr>
              <th class="text-center"><input type="checkbox" (click)="selectAll($event)" checked></th>
              <th class="text-center">Merchant Description</th>
            </tr>
            </thead>
            <tbody id="newMerchant">
            <tr *ngFor="let merchant of merchants | sort: 'descriptionLong'">
              <td class="text-center"><input id="{{ merchant.merchantId }}" type="checkbox" (click)="check($event)" checked [disabled]="merchant.descriptionLong === 'NAVY DISBURSING' " /></td>
              <td>{{ merchant.descriptionLong }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card-body" style="padding-top: 30px;padding-bottom: 30px">
        <h6 class="card-title">
          <span class="pull-right save-panel">
            <button type="submit"
                    class="btn btn-nc"
                    style="margin-right: 5px;"
                    [disabled]="validMerchants()">
              REGISTER
              <i [class]="save_ba_btn_spinner"></i>
            </button>
            <button type="button" (click)="onCancel()" class="btn cancel-btn">
              CANCEL
              <i ng-class="save_ba_btn_spinner"></i>
            </button>
          </span>
        </h6>
      </div>
    </form>
  </div>
</div>
